<template>
  <div class="storeReport">
    <iframe id="storeFrame" :src="src"></iframe>
  </div>
</template>
<script>
import axios from "axios";
function parseQueryString(url) {
  var obj = {};
  var keyvalue = [];
  var key = "",
    value = "";
  var pathUrl = url.substring(0, url.indexOf("?"))
  var paraString = url.substring(url.indexOf("?") + 1, url.length).split("&");
  for (var i in paraString) {
    keyvalue = paraString[i].split("=");
    key = keyvalue[0];
    value = keyvalue[1];
    obj[key] = value;
  }
  obj.pathUrl = pathUrl
  return obj;
}
export default {
  data() {
    return {
      src: ''
    }
  },
  mounted() {
    this.linkUrl();
    // let param = parseQueryString('http://dwglqas.lining.com/dgrpt/static/bi/index.html?type=shop&value=TjQyMkc')
    // console.log('param :>> ', param);
  },
  methods: {
    linkUrl() {
      axios({
        url: '/p/cs/getShopReportFormUrl',
        method: 'post',
        data: { 'id': this.$store.state.global.userInfo.id }
      }).then(res => {
        if (res.data.code == 0) {
          // console.log('res.data :>> ', res.data)
          let param = parseQueryString(res.data.data)
          console.log('storeFrame.param :>> ', param)
          this.src = param.pathUrl

          let frame = document.getElementById('storeFrame');
          frame.onload = function () {
            // iframe加载完成后要进行的操作
            console.log('storeFrame onload :>> ',);
            frame.contentWindow.postMessage({
              biType: param.type,
              // biType: 'dealer',
              biValue: param.value
            },
              '*');
          }
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
html {
  width: 100%;
  height: 100%;
}
.storeReport {
  width: 100%;
  height: 100%;
}
iframe {
  width: 100%;
  height: 100%;
}
</style>